import Loader from '../Loader';

const MainLoader = () => (
  <div className="h-full w-full flex items-center justify-center bg-white-brand-1">
    <Loader remSize={4} />
  </div>
);
export default MainLoader;
